import { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./FbBooknow.css";

const FBSlider = () => {
  const [astrologers, setAstrologers] = useState([]);

  useEffect(() => {
    fetch("https://dashboard.jyotirvani.com/api/fetchastrologer")
      .then((res) => res.json())
      .then((res) => {
        if (res.status && Array.isArray(res.data)) {
          const basePath = "https://dashboard.jyotirvani.com/" + res.path;

          const formatted = res.data.map((item) => ({
            id: item.id,
            name: item.name,
            experience: item.experience + " Years",
            languages: item.speak?.split(",").map((x) => x.trim()),
            expertise: item.Expertise?.split(",").map((x) => x.trim()),
            profileImage: basePath + item.profileimage,
            status: item.status === 1 ? "Online" : "Offline",
          }));

          setAstrologers(formatted);
        }
      })
      .catch(console.error);
  }, []);

  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 600,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="fbastro-slider-section">
      <div className="container">
        <h3 className="fbastro-slider-title">Meet Our Verified Astrologers</h3>

        <Slider {...settings}>
          {astrologers.map((astro) => (
            <div key={astro.id}>
              <div className="fbastro-card-wrap">
                <div className="fbastro-card">
                  <img
                    src={astro.profileImage}
                    alt={astro.name}
                    className="fbastro-card-img"
                  />

                  <h4 className="fbastro-card-name">{astro.name}</h4>
                </div>
              </div>
            </div>
          ))}
        </Slider>

        <h2 className="fbastro-bottom-title">
          ✨ Trusted by Thousands, Rooted in Scriptures
        </h2>

        <p className="fbastro-subtitle">
          JyotirVani सिर्फ एक सेवा नहीं — यह एक आध्यात्मिक यात्रा है।
        </p>
      </div>
    </div>
  );
};

export default FBSlider;